import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartjsService } from './chartjs.service';

@Component({
  selector: 'app-chartjs',
  templateUrl: './chartjs.component.html',
  styleUrls: ['./chartjs.component.css'],
  standalone: true,
  imports: [CommonModule],
  providers: [ChartjsService]
})
export class ChartjsComponent implements OnInit {

  @Input('insightId') insightId: string;
  @Input('insightData') insightData: any;
  @Input('configData') configOptions: any;
  private chartInstance: any;
  constructor(
    private chartjsService: ChartjsService,
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.insightId && this.insightData && this.configOptions) {
      if (this.configOptions.mergeSummary) {
        let formattedData = this.chartjsService.formatExecutiveSummaryData(this.insightData, this.configOptions);
        this.chartInstance = this.chartjsService.drawChart(this.insightId, formattedData);
      } else {
        let formattedData = this.chartjsService.formatChartData(this.insightData, this.configOptions);
        this.chartInstance = this.chartjsService.drawChart(this.insightId, formattedData);
      }
    }
  }


}
